export const userConstants = {
    ROLE_USER_MANAGER: 7,
    ROLE_AUDIT: 6,
    ROLE_SERVICE_DESK: 5,
    ROLE_APPROVER: 4,
    ROLE_USER: 3,
    ROLE_MANAGER: 2,
    ROLE_ADMIN: 1,

    BLOCK_MODE_AUTO: 0,
    BLOCK_MODE_ENABLED: 1,
    BLOCK_MODE_DISABLED: 2,
    BLOCK_MODE_NOT_CONFIGURED: 3,

    JOURNEY_MODE_FLEXIBLE: 0,
    JOURNEY_MODE_RIGID: 1,   
    JOURNEY_MODE_NOT_CONFIGURED: 2,    

    TRILEAN_FALSE: 0,
    TRILEAN_TRUE: 1,   
    TRILEAN_NOT_CONFIGURED: 2,    

    WORK_STATUS_ACTIVE: 0,
    WORK_STATUS_ABSENT: 1,

    APPROVAL_STEP_IMMEDIATE_SUPERIOR: 1,
    APPROVAL_STEP_MEDIATE_SUPERIOR: 2,
    APPROVAL_STEP_GROUP_APPROVERS: 3,

    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

    LOGOUT: 'USER_LOGOUT',

    CREATE_REQUEST: 'USER_CREATE_REQUEST',
    CREATE_SUCCESS: 'USER_CREATE_SUCCESS',
    CREATE_FAILURE: 'USER_CREATE_FAILURE',

    UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'USER_UPDATE_FAILURE',

    REMOVE_REQUEST: 'USER_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'USER_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'USER_REMOVE_FAILURE',

    FETCH_REQUEST: 'USER_FETCH_REQUEST',
    FETCH_SUCCESS: 'USER_FETCH_SUCCESS',
    FETCH_FAILURE: 'USER_FETCH_FAILURE',

    CREATE_GROUP_REQUEST: 'GROUP_CREATE_REQUEST',
    CREATE_GROUP_SUCCESS: 'GROUP_CREATE_SUCCESS',
    CREATE_GROUP_FAILURE: 'GROUP_CREATE_FAILURE',

    UPDATE_GROUP_REQUEST: 'GROUP_UPDATE_REQUEST',
    UPDATE_GROUP_SUCCESS: 'GROUP_UPDATE_SUCCESS',
    UPDATE_GROUP_FAILURE: 'GROUP_UPDATE_FAILURE',

    REMOVE_GROUP_REQUEST: 'GROUP_REMOVE_REQUEST',
    REMOVE_GROUP_SUCCESS: 'GROUP_REMOVE_SUCCESS',
    REMOVE_GROUP_FAILURE: 'GROUP_REMOVE_FAILURE',

    FETCH_GROUP_REQUEST: 'GROUP_FETCH_REQUEST',
    FETCH_GROUP_SUCCESS: 'GROUP_FETCH_SUCCESS',
    FETCH_GROUP_FAILURE: 'GROUP_FETCH_FAILURE',

    GET_GROUP_REQUEST: 'GROUP_USER_GET_REQUEST',
    GET_GROUP_SUCCESS: 'GROUP_USER_GET_SUCCESS',
    GET_GROUP_FAILURE: 'GROUP_USER_GET_FAILURE',

    SYNC_GROUP_AZURE_REQUEST: 'SYNC_GROUP_AZURE_REQUEST',
    SYNC_GROUP_AZURE_SUCCESS: 'SYNC_GROUP_AZURE_SUCCESS',
    SYNC_GROUP_AZURE_FAILURE: 'SYNC_GROUP_AZURE_FAILURE',

    SYNC_GROUP_AD_REQUEST: 'SYNC_GROUP_AD_REQUEST',
    SYNC_GROUP_AD_SUCCESS: 'SYNC_GROUP_AD_SUCCESS',
    SYNC_GROUP_AD_FAILURE: 'SYNC_GROUP_AD_FAILURE',

    MANAGERS_REQUEST: 'USER_MANAGERS_REQUEST',
    MANAGERS_SUCCESS: 'USER_MANAGERS_SUCCESS',
    MANAGERS_FAILURE: 'USER_MANAGERS_FAILURE',

    SUBORDINATES_REQUEST: 'USER_SUBORDINATES_REQUEST',
    SUBORDINATES_SUCCESS: 'USER_SUBORDINATES_SUCCESS',
    SUBORDINATES_FAILURE: 'USER_SUBORDINATES_FAILURE',

    GET_REQUEST: 'USER_GET_REQUEST',
    GET_SUCCESS: 'USER_GET_SUCCESS',
    GET_FAILURE: 'USER_GET_FAILURE',

    IMPORT_REQUEST: 'USER_IMPORT_REQUEST',
    IMPORT_SUCCESS: 'USER_IMPORT_SUCCESS',
    IMPORT_FAILURE: 'USER_IMPORT_FAILURE',

    ME_REQUEST: 'USER_ME_REQUEST',
    ME_SUCCESS: 'USER_ME_SUCCESS',
    ME_FAILURE: 'USER_ME_FAILURE',

    STATUS_REQUEST: 'USER_STATUS_REQUEST',
    STATUS_SUCCESS: 'USER_STATUS_SUCCESS',
    STATUS_FAILURE: 'USER_STATUS_FAILURE',

    WELCOME_EMAIL_REQUEST: 'USER_WELCOME_EMAIL_REQUEST',
    WELCOME_EMAIL_SUCCESS: 'USER_WELCOME_EMAIL_SUCCESS',
    WELCOME_EMAIL_FAILURE: 'USER_WELCOME_EMAIL_FAILURE',
};
